const calculateAge = (birthday: string): number => {
  if (!birthday) {
    throw new Error('Invalid birthday: undefined or null')
  }

  let birthDate: Date

  try {
    birthDate = new Date(birthday)
    if (isNaN(birthDate.getTime())) {
      throw new Error('Invalid date')
    }
  } catch (error) {
    throw new Error('Invalid date format')
  }

  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDifference = today.getMonth() - birthDate.getMonth()

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--
  }

  return age
}

export default calculateAge
